import _ from 'lodash'

intRegex   = /^-?\d+$/
floatRegex = /^-?\d+.?\d*$/
phoneRegex = /^(\+\d{3})?\ ?\d{9}$/
emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]{2,}$/

isNotEmpty   = (value) -> value not in [undefined, null, '', [], {}]
isValidEmail = (email) -> emailRegex.test(email)

## intended usage:
# spec =
#   property:  'password'
#   validator: [/\d/, /\w/, (pass) -> pass.length > 5]
# validator = SmartValidator.for(spec)
# validator('abc123') #> true
export default class SmartValidator
  constructor: (@validators) ->

  validate: (value) ->
    _.overEvery(@validators)(value)

  @for: (inputSpec) ->
    validators = _.compact(_.flatten([inputSpec.validator,
                                      @validatorForType(inputSpec.type or 'text')]))
    sValidator = new @(validators.map(@ensureFunction.bind(@)))

    sValidator.validate.bind(sValidator)

  @ensureFunction: (validator) ->
    if      _.isFunction(validator) then validator
    else if _.isRegExp(validator)   then @validatorForRegex(validator)
    else if _.isString(validator)   then @validatorForString(validator)
    else throw new Error("unknown validator type: #{JSON.stringify(validator)}")

  @validatorForType: (inputType) ->
    switch inputType
      when 'integer'          then 'isInteger'
      when 'float'            then 'isFloat'
      when 'email'            then 'email'
      when 'time-string'      then /^(\d|[0-1]\d|2[0-4]):[0-5]\d$/
      when 'time-as-duration' then /^(\d|[0-1]\d|2[0-4]):[0-5]\d$/
      when 'duration'         then /^\d+(:[0-5]\d)?$/

  @validatorForString: (name) ->
    validators =
      isInteger: @validatorForRegex(intRegex)
      isFloat:   @validatorForRegex(floatRegex)
      phone:     @validatorForRegex(phoneRegex)
      notEmpty:  isNotEmpty
      email:     (email)  -> not email or isValidEmail(email)
      positive:  (number) -> number > 0

    validators[name] or throw new Error("unknown validator #{name}")

  @validatorForRegex: (regex) ->
    (value) ->
      strValue = _.toString(value)

      _.isEmpty(strValue) or regex.test(strValue)
